import { render, staticRenderFns } from "./ServiceGroupEdit.vue?vue&type=template&id=2e7dd6b8&scoped=true&"
import script from "./ServiceGroupEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGroupEdit.vue?vue&type=style&index=0&id=2e7dd6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7dd6b8",
  null
  
)

export default component.exports